<template>
    <div class="container">
        <swiper :options="swiperOption" v-if="swiperOption">
            <swiper-slide>
                <div class="page-1 page">
                    <e-header></e-header>
                    <video
                        ref="video"
                        id="video"
                        autoplay="autoplay"
                        muted="muted"
                        src="http://img01.cmicawards.org.cn/cover/cma2019_slide.mp4"
                        loop="loop"
                    ></video>
                    <!-- <div :class="['p1','animated',showIndex >= 2 ? 'zoomIn show':'hide']" v-if="pageIndex == 1"><img src="../assets/images/index/01_logo.png"></div> -->
                    <div class="num">
                        <img src="../assets/images/index/01_top.png" />
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="page-2 page">
                    <div class="bg"></div>
                    <div class="num1">
                        <img src="../assets/images/index/01_down.png" />
                    </div>
                    <div class="num2">
                        <img src="../assets/images/index/02_top.png" />
                    </div>

                    <div class="content">
                        <div
                            class="title"
                            v-if="pageIndex == 2"
                            :class="['animated',showIndex >= 2 ? 'fadeInDown show':'hide' ]"
                        >
                            <div class="line"></div>
                            <h2><router-link to="/cma">奖项设置</router-link></h2>
                        </div>
                        <div class="group" v-if="pageIndex == 2">
                            <div class="item">
                                <div
                                    class="img"
                                    :class="['animated',showIndex >= 4 ? 'rotateInDownLeft show':'hide' ]"
                                >
                                    <img src="../assets/images/index/02_pic1.png" />
                                </div>
                                <router-link
                                    to="/cma"
                                    :class="['animated',showIndex >= 5 ? 'bounce show':'hide' ]"
                                >综合奖</router-link>
                                <div
                                    class="msg"
                                    :class="['animated',showIndex >= 4 ? 'fadeInUp show':'hide' ]"
                                >Annual Awards</div>
                            </div>
                            <div class="item">
                                <div
                                    class="img"
                                    :class="['animated',showIndex >= 2 ? 'rotateInDownLeft show':'hide' ]"
                                >
                                    <img src="../assets/images/index/02_pic2.png" />
                                </div>
                                <router-link
                                    to="/cma"
                                    :class="['animated',showIndex >= 3 ? 'bounce show':'hide' ]"
                                >单项奖</router-link>
                                <div
                                    class="msg"
                                    :class="['animated',showIndex >= 2 ? 'fadeInUp show':'hide' ]"
                                >Music Individual Awards</div>
                            </div>
                            <div class="item">
                                <div
                                    class="img"
                                    :class="['animated',showIndex >= 2 ? 'rotateInDownRight show':'hide' ]"
                                >
                                    <img src="../assets/images/index/02_pic3.png" />
                                </div>
                                <router-link
                                    to="/cma"
                                    :class="['animated',showIndex >= 3 ? 'bounce show':'hide' ]"
                                >技术奖</router-link>
                                <div
                                    class="msg"
                                    :class="['animated',showIndex >= 2 ? 'fadeInUp show':'hide' ]"
                                >Technical Individual Awards</div>
                            </div>
                            <div class="item">
                                <div
                                    class="img"
                                    :class="['animated',showIndex >= 4 ? 'rotateInDownRight show':'hide' ]"
                                >
                                    <img src="../assets/images/index/02_pic4.png" />
                                </div>
                                <router-link
                                    to="/cma"
                                    :class="['animated',showIndex >= 5 ? 'bounce show':'hide' ]"
                                >评委会奖</router-link>
                                <div
                                    class="msg"
                                    :class="['animated',showIndex >= 4 ? 'fadeInUp show':'hide' ]"
                                >Jury Awards</div>
                            </div>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="page-3 page">
                    <div class="bg"></div>
                    <div class="num">
                        <img src="../assets/images/index/02_down.png" />
                    </div>
                    <div class="content">
                        <div
                            class="title"
                            v-if="pageIndex == 3"
                            :class="['animated',showIndex >= 2 ? 'fadeInDown show':'hide' ]"
                        >
                            <div class="line"></div>
                            <h2>盛典</h2>
                        </div>
                        <div class="group" v-if="pageIndex == 3">
                            <a
                                href="https://www.iqiyi.com/v_19rrqrpooo.html"
                                target="_black"
                                :class="['animated',showIndex >= 2 ? 'fadeInLeft show':'hide' ]"
                            >
                                <div class="img">
                                    <img src="../assets/images/index/03_vedio1.png" />
                                </div>
                                <div class="title">CMIC Music Awards 2019</div>
                                <div
                                    class="msg"
                                >第3届唱工委音乐奖（又称：2019唱工委音乐奖）是中国音像与数字出版协会唱片工作委员会在中国主办的音乐类奖项，共设置36个奖项</div>
                            </a>
                            <a
                                href="https://www.iqiyi.com/v_19rqyit6f0.html"
                                target="_black"
                                :class="['animated',showIndex >= 2 ? 'fadeInUp show':'hide' ]"
                            >
                                <div class="img">
                                    <img src="../assets/images/index/03_vedio2.png" />
                                </div>
                                <div class="title">CMIC Music Awards 2018</div>
                                <div
                                    class="msg"
                                >第2届唱工委音乐奖（又称：2018唱工委音乐奖）是中国音像与数字出版协会唱片工作委员会在中国主办的音乐类奖项，共设置37个奖项</div>
                            </a>
                            <a
                                href="https://www.iqiyi.com/v_19rr7iicow.html"
                                target="_black"
                                :class="['animated',showIndex >= 2 ? 'fadeInRight show':'hide' ]"
                            >
                                <div class="img">
                                    <img src="../assets/images/index/03_vedio3.png" />
                                </div>
                                <div class="title">CMIC Music Awards 2017</div>
                                <div
                                    class="msg"
                                >首届唱工委音乐奖又称首届CMA音乐盛典，是由中国音像与数字出版协会唱片工作委员会主办的音乐类评奖，于2017年在中国举行并颁发，共设置32个奖项</div>
                            </a>
                        </div>
                    </div>
                    <div class="p-footer">
                        <e-footer></e-footer>
                    </div>
                </div>
            </swiper-slide>
            <div
                class="swiper-pagination"
                :id="pageIndex == 3 ? 'pagination-3' : '' "
                slot="pagination"
            ></div>
        </swiper>
		<!-- <div class="notice">
			“唱工委音乐奖CMA2020”，因疫情停办一年，计划明年合并举办，<router-link to="/cma/notice">点击查看</router-link>
		</div> -->
    </div>
</template>

<script>
import Vue from "vue";

import eHeader from "@/components/Header";
import eFooter from "@/components/Footer";

import animated from "animate.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(animated);

export default {
    name: "home",
    components: {
        eHeader,
        eFooter,
        swiper,
        swiperSlide,
    },
    data() {
        return {
            pageIndex: 0,
            showIndex: 1,
            timer: null,
            swiperOption: null,
        };
    },
    created() {
        const that = this;
        this.swiperOption = {
            direction: "vertical",
            mousewheel: {
				forceToAxis: true,
				invert: true
            },
            speed: 1000,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    let _index = index + 1;
                    _index = _index < 10 ? "0" + _index : _index;
                    return (
                        '<span class="' + className + '">' + _index + "</span>"
                    );
                },
            },
            on: {
                init() {
                    that.showPage(this.activeIndex);
                },
                slideChange() {
                    clearTimeout(that.timer);
                    // if( that.activeIndex == 0 ){
                    // 	that.$refs['video'].play()
                    // }else{
                    // 	that.$refs['video'].pause()
                    // }
                },
                slideChangeTransitionEnd() {
                    that.showPage(this.activeIndex);
                },
            },
        };
    },
    mounted() {},
    methods: {
        showPage(pageIndex) {
            const that = this;
            that.pageIndex = pageIndex + 1;
            that.showIndex = 0;

            // if( that.pageIndex == 1 ){
            // 	that.$refs['video'].play()
            // }else{
            // 	that.$refs['video'].pause()
            // }
            that.showIndex = 0;
            clearTimeout(that.timer);
            that.dtime(0);
        },
        dtime(time) {
            var that = this,
                _time = time;
            if (_time > 10) {
                return;
            } else {
                that.showIndex += 1;
                _time++;
                that.timer = setTimeout(function () {
                    that.dtime(_time);
                }, 500);
            }
        },
    },
    beforeDestroy() {},
};
</script>
<style lang="scss">
.container {
    .page-1 {
        .header {
            .menus .el-menu .el-menu-item {
                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
            }
        }
    }
    .swiper-pagination {
        right: 30px;
        .swiper-pagination-bullet {
            width: auto;
            height: auto;
            background: transparent;
            font-size: 16px;
            color: #fff;
            opacity: 0.5;
            margin: 20px 0;
            &.swiper-pagination-bullet-active {
                opacity: 1;
            }
        }
        &#pagination-3 {
            .swiper-pagination-bullet {
                color: #333;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.header {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    background: transparent;
    z-index: 1;
    .content {
        background: none !important;
    }
}
.container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    .hide {
        visibility: hidden;
    }
    .show {
        visibility: visible;
    }
    .swiper-container {
        height: 100%;
        .page {
            width: 100%;
            height: 100%;
            img {
                vertical-align: middle;
            }
            &.page-1 {
                overflow: hidden;
                video {
                    height: 100%;
                    width: 100%;
                    -o-object-fit: cover;
                    object-fit: cover;
                }
                .p1 {
                    position: absolute;
                    right: 150px;
                    top: 50%;
                    margin-top: -200px;
                }
                .num {
                    position: absolute;
                    left: 206px;
                    bottom: 0;
                    img {
                        width: 100%;
                    }
                }
            }
            &.page-2 {
                .bg {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    background: url("~@/assets/images/index/02_bg.png")
                        no-repeat center center;
                    background-size: cover;
                }

                .num1 {
                    position: absolute;
                    left: 206px;
                    top: 0;
                    img {
                        width: 100%;
                    }
                }
                .num2 {
                    position: absolute;
                    right: 206px;
                    bottom: 0;
                    img {
                        width: 100%;
                    }
                }
                .content {
                    margin-top: -320px;
                    .title {
                        h2 a {
                            color: #fff;
                        }
                    }
                    .group {
                        margin-top: 70px;
                        // overflow: hidden;
                        padding: 0 50px;
                        .item {
                            float: left;
                            margin: 0 15px;
                            width: 245px;
                            text-align: center;
                            position: relative;
                            .img {
                                margin-bottom: -30px;
                                img {
                                    max-width: 100%;
                                }
                            }
                            a {
                                display: inline-block;
                                width: 104px;
                                height: 104px;
                                line-height: 104px;
                                background: #ff1b98;
                                color: #fff;
                                font-size: 20px;
                                border-radius: 100%;
                                margin-top: -50px;
                                position: relative;
                                z-index: 1;
                                &:hover {
                                    background: #fff;
                                    color: #ff1b98;
                                }
                            }
                            .msg {
                                margin-top: 20px;
                                font-size: 18px;
                                color: rgba(255, 255, 255, 0.6);
                            }
                        }
                    }
                }
            }
            &.page-3 {
                background: #f0f0f0;
                .bg {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    background: url("~@/assets/images/index/03_bg.png")
                        no-repeat center center;
                    background-size: cover;
                }

                .num {
                    position: absolute;
                    right: 206px;
                    top: 0;
                    img {
                        width: 100%;
                    }
                }
                .content {
                    margin-top: -300px;
                    .title {
                        h2 {
                            color: #000;
                        }
                    }
                    .group {
                        overflow: hidden;
                        margin-top: 60px;
                        a {
                            display: block;
                            width: 380px;
                            margin-right: 30px;
                            float: left;
                            color: #000;
                            &:last-child {
                                margin-right: 0;
                            }
                            .title {
                                font-size: 18px;
                                margin: 48px 0 20px 0;
                                text-align: left;
                            }
                            .msg {
                                font-size: 12px;
                                color: #909399;
                                line-height: 20px;
                            }
                            .img {
                                overflow: hidden;
                            }
                            img {
                                width: 100%;
                                transition-delay: 0.1s;
                                transition: transform 0.6s ease-in-out,
                                    opacity 0.5s;
                            }

                            &:hover {
                                img {
                                    transform: scale(1.05);
                                }
                            }
                        }
                    }
                }
                .p-footer {
                    position: absolute;
                    width: 100%;
                    left: 0;
                    bottom: 20px;
                }
            }
            .content {
                position: absolute;
                width: 1200px;
                top: 50%;
                left: 50%;
                margin-left: -600px;
                .title {
                    text-align: center;
                    .line {
                        width: 70px;
                        height: 6px;
                        background: #ff1b98;
                        display: inline-block;
                    }
                    h2 {
                        font-size: 40px;
                        margin-top: 18px;
                        font-weight: 700;
                    }
                }
            }
        }
    }
}

@media screen and (max-height: 920px) and (max-width: 1370px) {
    .container {
        .swiper-container {
            .page {
                &.page-1 {
                    .num {
                        width: 100px;
                    }
                }
                &.page-2 {
                    .num1 {
                        width: 100px;
                    }
                    .num2 {
                        width: 140px;
                    }
                    .content {
                        width: 880px;
                        margin-left: -440px;
                        margin-top: -300px;
                        .group {
                            padding: 0;
                            .item {
                                width: 190px;
                                a {
                                    width: 80px;
                                    height: 80px;
                                    line-height: 80px;
                                    font-size: 16px;
                                }
                            }
                        }
                    }
                }
                &.page-3 {
                    .num {
                        width: 140px;
                    }
                    .content {
                        width: 960px;
                        margin-left: -480px;
                        .group {
                            a {
                                width: 300px;
                                margin-right: 30px;

                                .title {
                                    margin: 30px 0 15px 0;
                                }
                            }
                        }
                    }
                }
                .content {
                    .title {
                        .line {
                            width: 60px;
                            height: 4px;
                        }
                        h2 {
                            font-size: 28px;
                        }
                    }
                }
            }
        }
    }
}


.notice{
	position: fixed;
	z-index: 999999;
	left: 50%;
	margin-left: -450px;
	top: 100px;
	width:900px;
	height:50px;
	line-height: 50px;
	background:#CD1E77;
	border-radius:25px;
	text-align: center;
	font-size:16px;
	color: #fff;
	a{
		color: #fff;
	}
}

</style>